import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  createPaymentUrl,
  createPayOSUrl,
  processVNPayReturn,
  processPayOSReturn,
} from "@/services/paymentService";

// Tạo URL thanh toán VNPay
export const fetchPaymentUrl = createAsyncThunk(
  "payment/fetchPaymentUrl",
  async (paymentData, { rejectWithValue }) => {
    try {
      const response = await createPaymentUrl(paymentData);
      return response.url;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Payment request failed");
    }
  }
);

// Tạo URL thanh toán PayOS
export const fetchPayOSUrl = createAsyncThunk(
  "payment/fetchPayOSUrl",
  async (paymentData, { rejectWithValue }) => {
    try {
      const response = await createPayOSUrl(paymentData);
      return response.url;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "PayOS payment request failed"
      );
    }
  }
);

// Xử lý phản hồi sau khi thanh toán VNPay
export const handleVNPayReturn = createAsyncThunk(
  "payment/handleVNPayReturn",
  async (queryParams, { rejectWithValue }) => {
    try {
      const response = await processVNPayReturn(queryParams);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Lỗi không xác định" }
      );
    }
  }
);

// Xử lý phản hồi sau khi thanh toán PayOS
export const handlePayOSReturn = createAsyncThunk(
  "payment/handlePayOSReturn",
  async (queryParams, { rejectWithValue }) => {
    try {
      const response = await processPayOSReturn(queryParams);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Lỗi không xác định" }
      );
    }
  }
);

const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    paymentUrl: null,
    loading: false,
    error: null,
    booking: null,
    payment: null,
    userInfo: null,
    message: "",
    success: null,
    selectedPaymentMethod: "vnpay", // Thêm state để lưu phương thức thanh toán được chọn
  },
  reducers: {
    resetPaymentState: (state) => {
      state.success = null;
      state.message = "";
      state.booking = null;
      state.payment = null;
      state.user = null;
    },
    setPaymentMethod: (state, action) => {
      state.selectedPaymentMethod = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // VNPay cases
      .addCase(fetchPaymentUrl.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPaymentUrl.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentUrl = action.payload;
      })
      .addCase(fetchPaymentUrl.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(handleVNPayReturn.pending, (state) => {
        state.loading = true;
        state.success = null;
      })
      .addCase(handleVNPayReturn.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
        state.booking = action.payload.booking;
        state.payment = action.payload.payment;
        state.userInfo = action.payload.user;
      })
      .addCase(handleVNPayReturn.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.message = action.payload?.message || "Thanh toán thất bại";
      })
      // PayOS cases
      .addCase(fetchPayOSUrl.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPayOSUrl.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentUrl = action.payload;
      })
      .addCase(fetchPayOSUrl.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(handlePayOSReturn.pending, (state) => {
        state.loading = true;
        state.success = null;
      })
      .addCase(handlePayOSReturn.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
        state.booking = action.payload.booking;
        state.payment = action.payload.payment;
        state.userInfo = action.payload.user;
      })
      .addCase(handlePayOSReturn.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.message = action.payload?.message || "Thanh toán thất bại";
      });
  },
});
export const { resetPaymentState, setPaymentMethod } = paymentSlice.actions;
export default paymentSlice.reducer;
